import {DeniedEventsMapper} from '@/constants';
import moment from 'moment';

export const toPhilMoment = (utcMoment) => {
  return moment.utc(utcMoment).add(8, 'hours');
};

export const formatDate = (date, format) => toPhilMoment(date).format(format);

export const messageDateFormatter = (messageDate) => { //message date is ISO string
  const date = toPhilMoment(messageDate);
  const now = moment.utc([]);
  const startOfWeek = moment.utc([]).startOf('week');
  const startOfYear = moment.utc([]).startOf('year');
  if (date.isSame(now, 'day')) {
    return date.format('hh:mm a');
  } else if (date.isBetween(startOfWeek, now)) {
    return date.format('ddd');
  } else if (date.isBetween(startOfYear, now)) {
    return date.format('MMM D');
  } else {
    return date.format('M/D/YY');
  }
};

export const convertDuration = (miliseconds) => {
  var hours, minutes, seconds, total_hours, total_minutes, total_seconds, hours_str, minutes_str, seconds_str;

  if (miliseconds < 1000) {
    return 'No duration.';
  }

  total_seconds = parseInt(Math.floor(miliseconds / 1000));
  total_minutes = parseInt(Math.floor(total_seconds / 60));
  total_hours = parseInt(Math.floor(total_minutes / 60));

  seconds = parseInt(total_seconds % 60);
  minutes = parseInt(total_minutes % 60);
  hours = parseInt(total_hours % 24);

  hours_str = hours > 0 ? `${hours} hour/s ` : '';
  minutes_str = minutes > 0 ? `${minutes} minute/s ` : '';
  seconds_str = seconds > 0 ? `${seconds} second/s ` : '';


  return hours_str + minutes_str + seconds_str;
};

export const sortByNearestDate = (prevAppointment, nextAppointment) => {
  const prevDate = prevAppointment.starttime ? toPhilMoment(prevAppointment.starttime) : toPhilMoment(prevAppointment.date);
  const nextDate = nextAppointment.starttime ? toPhilMoment(nextAppointment.starttime) : toPhilMoment(nextAppointment.date);

  if (!prevDate.isValid()) {
    return 1;
  } else if (!nextDate.isValid()) {
    return -1;
  }

  if (DeniedEventsMapper[prevAppointment.status]) {
    if (DeniedEventsMapper[nextAppointment.status]) {
      if (prevDate.isBefore(nextDate, 'hour')) {
        return 1;
      }

      if (prevDate.isSame(nextDate, 'day')) {
        return 0;
      }

      return -1;
    }

    return 1;
  } else {
    if (DeniedEventsMapper[nextAppointment.status]) {
      return -1;
    }

    if (prevDate.isBefore(nextDate, 'hour')) {
      return -1;
    }

    if (prevDate.isSame(nextDate, 'day')) {
      return 0;
    }

    return 1;
  }
};

export const getNextOkDate = () => {
  const dateMoment = moment.utc();

  do {
    dateMoment.add(1, 'day');
  } while (dateMoment.get('e') === 0);

  return moment.utc(dateMoment.format('YYYY-MM-DD' + 'T02:00:00Z')).valueOf();
};
